/** @format */

import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss'],
    standalone: false
})
export class NavMenuComponent implements OnInit, OnChanges {
	@Input() role: string[] | null = null;
	@Input() isLoadingData = false;

	constructor(private router: Router, private changeDetectorRef: ChangeDetectorRef) {}

	ngOnInit(): void {
		// console.log('nav menu: ', this.role);
		this.router.events.subscribe((val) => {
			if (val instanceof NavigationEnd) {
				this.changeDetectorRef.detectChanges();
			}
		});
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.role && changes.role.currentValue !== changes.role.previousValue && changes.role.currentValue.length > 0) {
			this.changeDetectorRef.detectChanges();
		}
	}

	isCurrentActiveRoute(routePath: string) {
		const currentActiveUrl = this.router.url;
		const pageUrl = currentActiveUrl.includes(';') ? currentActiveUrl.split(';')[0] : currentActiveUrl;
		return pageUrl.toLowerCase() == routePath.toLowerCase();
	}

	isManagerOrTimeKeeper(): boolean {
		return this.isManager() || this.isTimeKeeper();
	}

	isManager(): boolean {
		let result = false;
		this.role?.forEach((r: string) => {
			if (r.toLowerCase() === 'manager') {
				result = true;
			}
		});

		return result;
		// return true;
	}

	isTimeKeeper(): boolean {
		let result = false;
		this.role?.forEach((r: string) => {
			if (r.toLowerCase() === 'timekeepers') {
				result = true;
			}
		});

		return result;
		// return true;
	}
}
